module.exports = __webpack_public_path__ + "img/definitive.b9f49b9b.svg";